export const MODULE_NAME = 'axp-travel-search-hotels';
export const ROOT_MODULE_NAME = 'axp-consumer-travel-root';
export const ROOMS_TRAVELERS_MODULE_NAME = 'axp-travel-search-rooms-travelers';
export const SEARCH_REDIRECT_MODULE_NAME = 'axp-travel-search-redirect';
export const DATE_PICKER_MODULE_NAME = 'axp-travel-search-date-picker';
export const LOCATIONS_MODULE_NAME = 'axp-travel-search-locations';

export const HOMEPAGE_REDESIGN_EXPERIMENT = 'prebooking_hp_search_widget_redesign';
